import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { url } from "../../../../../../Config/Config";
import { useStyles } from "../../../../../../Components/CSS/TableStyle.css";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CustomDialogBox from "../../../../../../Components/CustomDialogBox/CustomDialogBox";
import AddFeeHead from "../AddFeeHead/AddFeeHead";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";

class FeeHeadBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      editStatus: false,
      groupFeeHeadId: "",
    };
  }

  handleEdit = (groupFeeHeadId) => {
    this.setState({
      editStatus: true,
      groupFeeHeadId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (groupFeeHeadId) => {
    this.setState({
      dialogOpen: true,
      groupFeeHeadId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteFeeHead = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/fee-groups/${this.props.groupId}/fee/${this.props.data._id}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Fee deleted successfully from fee group") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getGroupDetails(this.props.groupId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteFeeHead();
      }
    }
  };

  render() {
    const { classes, index, data } = this.props;
    return this.state.editStatus ? (
      <AddFeeHead
        editStatus={true}
        data={data}
        groupId={this.props.groupId}
        handleCancelEdit={this.handleCancelEdit}
        getGroupDetails={this.props.getGroupDetails}
      />
    ) : (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.feeTypeName}</TableCell>
        <TableCell align="center">{data.price}</TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Edit"
            className={classes.tooltip}
            onClick={() => this.handleEdit(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Delete"
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteFeeHead}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(FeeHeadBody)));
